import { useCallback, useEffect, useState } from 'react';

import Switch from 'approot/shared/switch/switch';
import {
  isSpanishSupportEnabled,
  toggleSpanishSupportEnabled,
} from 'approot/lesson/lesson-spanish-switch.utils';
import * as Styled from 'approot/lesson/lesson-spanish-switch.style';
import TooltipWrapper from 'approot/shared/tooltip/tooltip-wrapper';
import { pushDataTrackerEvent } from 'approot/shared/data-tracker/data-tracker-push';
import {
  EVENT_ACTION_SWITCH,
  EVENT_CATEGORY_ACTIVITY_COMPONENT,
} from 'approot/shared/data-tracker/data-events.constants';
import {
  ASSESSMENT,
  ActivitiesContentType,
  LESSON,
  LESSON_ACTIVITIES,
} from 'global/constants';

const LessonSpanishSwitch = ({
  isSpanishSupportAvailable,
  sectionId,
  contentId,
  contentType,
  componentId,
}: {
  isSpanishSupportAvailable: boolean;
  sectionId: string;
  contentId: number;
  contentType: ActivitiesContentType;
  componentId: string;
}) => {
  const [isEnabled, setIsEnabled] = useState<boolean>(
    isSpanishSupportEnabled()
  );
  const toggleSwitch = useCallback(() => {
    toggleSpanishSupportEnabled();
    setIsEnabled(prev => !prev);
    pushDataTrackerEvent(
      EVENT_CATEGORY_ACTIVITY_COMPONENT,
      EVENT_ACTION_SWITCH,
      {
        target_type: 'vocabulary',
        target_identifier: componentId,
        content_id: contentId,
        content_type: contentType === LESSON_ACTIVITIES ? LESSON : ASSESSMENT,
        section_id: sectionId,
        switch_identifier: 'enable_spanish',
        state: isEnabled ? 'off' : 'on',
      }
    );
  }, [componentId, contentId, contentType, sectionId, isEnabled]);

  // keep the switch in sync with local storage
  useEffect(() => {
    const handleStorageChange = () => {
      setIsEnabled(isSpanishSupportEnabled());
    };
    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const enableSpanishSwitch = (
    <Switch
      ariaLabel={`Click to ${
        isEnabled ? 'disable' : 'enable'
      } Spanish Vocabulary`}
      state={isEnabled && isSpanishSupportAvailable}
      onClick={isSpanishSupportAvailable ? toggleSwitch : undefined}
    />
  );
  return (
    <Styled.LessonSpanishSwitchWrapper>
      {isSpanishSupportAvailable ? (
        enableSpanishSwitch
      ) : (
        <TooltipWrapper hoverText="Spanish isn’t available for this lesson yet">
          {enableSpanishSwitch}
        </TooltipWrapper>
      )}
      <Styled.LessonSpanishSwitchText>
        Enable Spanish
      </Styled.LessonSpanishSwitchText>
    </Styled.LessonSpanishSwitchWrapper>
  );
};

export default LessonSpanishSwitch;
